import * as React from "react"

import { cn } from "@/lib/utils"

const Card = React.forwardRef(({ className, variant = "default", ...props }, ref) => {
  const variants = {
    default: "rounded-xl border border-border bg-card text-card-foreground shadow-md",
    elevated: "rounded-xl border border-border-light bg-card-elevated text-card-foreground shadow-lg",
    luxury: "rounded-xl border border-silver/20 bg-gradient-card text-card-foreground shadow-lg hover-glow",
    glass: "rounded-xl border border-silver/10 bg-card/80 backdrop-blur-md text-card-foreground shadow-md",
    product: "rounded-xl border border-border bg-card text-card-foreground shadow-md overflow-hidden transition-all duration-300 hover:shadow-xl hover:border-silver/30",
  }
  
  return (
    <div
      ref={ref}
      className={cn(variants[variant] || variants.default, className)}
      {...props} />
  )
})
Card.displayName = "Card"

const CardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex flex-col space-y-1.5 p-6", className)}
    {...props} />
))
CardHeader.displayName = "CardHeader"

const CardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn("font-display text-xl font-semibold leading-tight tracking-tight", className)}
    {...props} />
))
CardTitle.displayName = "CardTitle"

const CardDescription = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn("text-sm text-muted-foreground font-body", className)}
    {...props} />
))
CardDescription.displayName = "CardDescription"

const CardContent = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("p-6 pt-0", className)} {...props} />
))
CardContent.displayName = "CardContent"

const CardFooter = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex items-center p-6 pt-0", className)}
    {...props} />
))
CardFooter.displayName = "CardFooter"

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }
